import { API, Endpoints } from '@brg/api';

type ChangeFtblClubParams = {
  teamId: string;
};

export const changeFtblClub = ({ teamId }: ChangeFtblClubParams) => (
  API.request()
    .endpoint(Endpoints.geograffee)
    .url('/api/Team/ChangeFTBLClub')
    .post()
    .body({ teamId })
    .send()
);
import { API, Endpoints } from '@brg/api';

type ChangeFtblClubParams = {
  teamId: string;
};

export const changeFtblClub = ({ teamId }: ChangeFtblClubParams) => (
  API.request()
    .endpoint(Endpoints.geograffee)
    .url('/api/Team/ChangeFTBLClub')
    .post()
    .body({ teamId })
    .send()
);
